import { TypedDocumentNode, gql } from '@apollo/client';

import { useTypedParams } from '@sorare/routing';

import { LoadingIndicator } from '@sorare/core/src/atoms/loader/LoadingIndicator';
import { useQuery } from '@sorare/core/src/hooks/graphql/useQuery';

import { Transactions } from '@sorare/marketplace/src/components/player/Transactions';

import {
  NbaPlayerTransactionsQuery,
  NbaPlayerTransactionsQueryVariables,
} from './__generated__/page.graphql';
import { PageParams } from './__generated__/routeParams';

const NBA_PLAYER_TRANSACTIONS_QUERY = gql`
  query NbaPlayerTransactionsQuery($slug: String!) {
    anyPlayer(slug: $slug) {
      slug
      displayName
      ...Transactions_anyPlayerInterface
    }
  }

  ${Transactions.fragments.anyPlayer}
` as TypedDocumentNode<
  NbaPlayerTransactionsQuery,
  NbaPlayerTransactionsQueryVariables
>;

const TransactionsPage = () => {
  const { slug } = useTypedParams<PageParams>();
  const { data, loading } = useQuery(NBA_PLAYER_TRANSACTIONS_QUERY, {
    variables: {
      slug,
    },
  });

  const anyPlayer = data?.anyPlayer;

  if (loading) return <LoadingIndicator fullHeight />;
  if (!anyPlayer) return null;

  return <Transactions anyPlayer={anyPlayer} />;
};

export default TransactionsPage;
